import { credentialingReducer } from 'src/app/credentialing/+store/reducers/credentialing.reducer';
import { autoAssignReducer } from 'src/app/credentialing/+store/reducers/autoassign.reducer';

export const credentialingReducers = {
    credentialing: credentialingReducer,
    autoAssign: autoAssignReducer
};
